import {
  PROMPT_CATEGORIES as DRAWER_PROMPT_CATEGORIES,
  STARTER_PROMPTS as DRAWER_STARTER_PROMPTS,
} from "connected-components/ai-teammate/helpers/constants"

// Single source of truth: the drawer's canonical prompts (APP-3404). Kelly consumes the text only;
// the classification set (SUGGESTED_PROMPT_TEXTS) derives from these same lists so the two never drift.
export const STARTER_PROMPTS = DRAWER_STARTER_PROMPTS.map((prompt) => prompt.text)

// "Browse topics" categories, reshaped to Kelly's text-only shape (theme keys the accordion; label is the chip).
export const PROMPT_CATEGORIES = DRAWER_PROMPT_CATEGORIES.map((category) => ({
  theme: category.theme,
  label: category.label,
  prompts: category.prompts.map((prompt) => prompt.text),
}))

// Every suggested-prompt text (starters + category prompts): send-source analytics classify these as "suggested".
export const SUGGESTED_PROMPT_TEXTS = [
  ...STARTER_PROMPTS,
  ...PROMPT_CATEGORIES.flatMap((category) => category.prompts),
]
